





































import { computed, defineComponent } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import ImagePreview from "@/components/ImagePreview";

interface FormFileData {
  data: FileList | FileData | null;
}

export default defineComponent({
  name: "AgeVerificationInputFile",
  components: { ImagePreview, LoadingThumbnail, BaseInputFile, BaseButton, BaseIcon },
  props: {
    value: { type: Object as () => FormFileData, readonly: true },
    uploadingProgress: { type: Number, readonly: true },
    loading: { type: Boolean, readonly: true, default: false },
  },
  setup(props) {
    const inputSrc = computed(() => {
      if (!props.value || !props.value.data) return "";
      return props.value.data instanceof FileList
        ? URL.createObjectURL(props.value.data[0])
        : MediaFilesController.getImageThumbnail(props.value.data.urlPart, 122);
    });

    return { inputSrc };
  },
});
